<template>
    <div class="task-box">
        <div class="top-box">
            <div class="btn-box" @click="publishTask">
                <i class="iconfont icon-jiahao"></i>
                发布任务
            </div>
            <div class="input-box">
                <div @click="search">搜索</div>
                <el-input v-model="pages.keywords" style="width: 20rem;" clearable @clear="search" @keydown.enter.native="search" placeholder="请输入关键字">
                    <template slot="prefix">
                        <div class="search-ipt-box">
                            <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                        </div>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="table-content-box">
            <Table
                    :totalSize="pages.total"
                    :pagination="true"
                    :serialNumber="true"
                    @changeCurrentPage="changeCurrentPage" 
                    @changePageSize="changePageSize"
                    :operationWidth="350"
                    :currentPage="pages.current"
                    :pageSize="pages.size"
                    navHeight=40
                    ref="table"
                    :tableData="tableData"
                    :tableKey="tableKey"
                >
                <template slot="courseName" slot-scope="data">
                    <p>{{ filterCourseName(data.data.row.courseData)}}</p>
                </template>
                <template slot="operation" slot-scope="data">
                    <div class="operation-box">
                        <el-tooltip class="item" effect="dark" content="学习记录" placement="top-start">
                            <i class="iconfont icon-lishi" @click="studyHistory(data.data.row)"></i>
                        </el-tooltip> 
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="iconfont icon-bianji1" @click="edit(data.data.row)"></i>
                        </el-tooltip> 
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="iconfont icon-shanchu" @click="delCourseTask(data.data.row)"></i>
                        </el-tooltip> 
                    </div>
                </template>
            </Table>
        </div>
        <publish-task ref="publish_task" @create_success="pageTaskList"></publish-task>
        <course-task-history ref="course_task_history"></course-task-history>
    </div>
</template>

<script>
import { PageTaskList,DelCourseTask } from '@/api/courseTask';
import PublishTask from './PublishTask.vue';
import CourseTaskHistory from './CourseTaskHistory.vue';
    export default {
  components: { PublishTask, CourseTaskHistory },
        data(){
            return {
                pages:{
                    total:0,
                    current:1,
                    size:10,
                    keywords:''
                },
                tableData:[],
                tableKey:[
                {name: '任务名称', value: 'taskName'},
                {name: '所属课程', value: 'courseName',slot:'courseName'},
                {name: '任务内容', value: 'taskContent'},
                {name: '发布时间', value: 'releaseTime'},
                {name: '操作', value: 'operation',slot:'operation'},
                ]
            }
        },
        methods:{
              /**过滤课程名称 */
              filterCourseName(courseData){
                if(!courseData){
                  return '';
                }
                let arr=courseData.map(item=>item.courseName+`（第${item.periods}期）`);
                return arr.join(',');
            },
            /**发布任务 */
            publishTask(){
                let dialog=this.$refs.publish_task;
                if(dialog){
                    dialog.dialogVisible=true;
                    dialog.operation='add';
                    dialog.getClassList();
                    dialog.search();
                }
            },
            /**查看学习历史 */
            studyHistory(data){
               let dialog=this.$refs.course_task_history;
               let options=data.courseData.map(item=>{
                return {
                    label:item.courseName+`（第${item.periods}期）`,
                    value:item.openCourseId,
                    courseId:item.id
                }
               });
               if(dialog){
                dialog.dialogVisible=true;
                dialog.courseTaskId=data.id;
                dialog.options=options;
                if(options.length>0){
                    dialog.courseInfo.openCourseId=options[0].value;
                    dialog.courseInfo.id=options[0].courseId;
                    dialog.getCourseStudyUser();
                }
               }
            },
            /**编辑任务 */
            edit(data){
                let dialog=this.$refs.publish_task;
                if(dialog){
                    dialog.form.taskName=data.taskName;
                    dialog.form.taskContent=data.taskContent;
                    dialog.form.classIds=data.classData?data.classData.map(item=>item.id):[];
                    dialog.form.courseIds=data.courseData?data.courseData.map(item=>item.id):[];
                    dialog.dialogVisible=true;
                    dialog.taskId=data.id;
                    dialog.operation='edit';
                    dialog.getClassList();
                    dialog.search();
                }
            },
            changeCurrentPage(e){
                this.pages.current=e;
                this.pageTaskList();
            },
            changePageSize(e){
                this.pages.current=1;
                this.pages.size=e;
                this.pageTaskList();
            },
            /**删除任务 */
            delCourseTask(data){
                this.$confirm('是否确认删除该条数据?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    DelCourseTask({ids:[data.id]}).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "删除任务成功",
                            type: "success",
                        });
                        if(this.tableData.length==1&&this.pages.current>1){
                            this.pages.current--;
                        }
                        this.pageTaskList();
                    }
                })
                  });
            },
            /**分页查询课程任务 */
            pageTaskList(){
                let params={
                "current": this.pages.current,
                "size": this.pages.size,
                "taskName": this.pages.keywords
                }
                PageTaskList(params).then(res=>{
                    if(res.code==200){
                        this.pages.total=res.data.total;
                        this.tableData=res.data.records;
                    }
                })
            },
            /**关键字搜索 */
            search(){
                this.pages.current=1;
                this.pageTaskList();
            }
        },
        mounted(){
            this.search();
        }
    }
</script>

<style lang="less" scoped>
.task-box{
    height: calc(100% + 1rem);
    .top-box{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
}
.btn-box{
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    i{
        margin-right: 3px;
        font-size: 2rem;
    }
}
.input-box{
    display: flex;
    align-items: center;
    color: #334681;
    &> :nth-child(1){
        margin-right: 1.3rem;
        cursor: pointer;
        color: #8590B3;
    }
}
.input-box{
/deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
.table-content-box{
    height: calc(100% - 4rem);
    padding: 2rem 0 1rem 0;
}
.operation-box{
    display: flex;
    &> :nth-child(n){
        margin-left: 1rem;
        color: var(--blue);
        cursor: pointer;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
    i{
        font-size: 16px;
    }
}
</style>